import { JsonService } from 'src/json-util';
import { ClubMembership, ClubInfo } from 'src/data/mygolf.data';
import { NavController, NavParams, ModalController } from "@ionic/angular";
import { Component } from "@angular/core";
import { AuthenticationService } from "src/authentication-service";
import { getDistanceInKM } from "src/globals";
import { ClubList, createClubList } from "src/data/club-course";
import { GeolocationService } from "src/providers/geolocation-service/geolocation-service";
import { ClubService } from "src/providers/club-service/club-service";

/**
 * The competition list page class. This class lists the competitions. There are
 * three types of listing
 *  This class extends Subscriber which is passed as parameter for Remote Http method so that
 *  results are processed
 */
@Component({
    templateUrl: 'club-membership-list.html',
    selector: 'club-membership-list-page',
    styleUrls: ['club-membership-list.scss'],
})
export class ClubMembershipListPage {
    clubList: ClubList;
    openedModal: boolean = false;
    searchQuery: string;
    memberships: Array<ClubMembership>;

    constructor(private nav: NavController,
        private navParams: NavParams,
        private auth: AuthenticationService,
        private geo: GeolocationService,
        private clubService: ClubService,
        private modalCtrl: ModalController) {
        this.clubList = createClubList();
        this.openedModal = navParams.get("openedModal");
        this.memberships = navParams.get("clubMemberships");
    }

    ionViewDidLoad() {
        this.refreshClubs(null, null);
    }

    onSearchInput(event) {
        this._clearItems();
        this.refreshClubs(null, null);
    }

    /**
     * Gets the distance between a current location and club in KMs
     * @param club The club information
     * @returns {number} Returns the distance in KM if GPS locations of current and club are available
     * else returns 0;
     */
    clubDistance(club: ClubInfo): string {
        let lat1 = this.geo.getLatitude();
        let lon1 = this.geo.getLongitude();
        if (lat1 != null && lon1 != null && club.latitude != null && club.longitude != null)
            return getDistanceInKM(lat1, lon1, club.latitude, club.longitude) + " KM";
        return "";
    }

    /**
     * Executed when refresh button on toolbar is clicked
     */
    onRefreshClick(refresher) {
        this._clearItems();
        this.refreshClubs(refresher, null);
    }

    doInfinite(infinite) {

        if (this.isMore()) {
            this.refreshClubs(null, infinite);
        }
        // else {
        //     infinite.complete();
        //     infinite.enable(false);
        // }

    }

    clubSelected(event, item: ClubInfo) {

        if (this.openedModal) {
            this.modalCtrl.dismiss(item);
        }
    }

    close() {
        this.modalCtrl.dismiss();
    }

    private _clearItems() {
        this.clubList = createClubList();
    }

    refreshClubs(refresher, infinite) {
        this.clubService.searchClubs(this.searchQuery, true, this.clubList.currentPage + 1)
            .subscribe((clubList: ClubList) => {
                // if (clubList.totalPages > 0)
                //     clubList.currentPage++;
                this.clubList.currentPage = clubList.currentPage;
                this.clubList.totalPages = clubList.totalInPage;
                this.clubList.totalItems = clubList.totalItems;
                this.clubList.clubs.push(...clubList.clubs);

            }, (error) => {

            }, () => {
                //Handle the refresher or infinite
                if (refresher && refresher.complete) refresher.complete();
                if (infinite) {
                    if (infinite.complete) infinite.complete();
                    if (this.isMore()) {
                        infinite.enable(true);
                    }
                    else infinite.enable(false);
                }
            });
    }

    isMore(): boolean {
        return this.clubList.totalPages > 0
            && this.clubList.currentPage < this.clubList.totalPages;
    }

    onClubSelect(membership: ClubMembership) {
        this.modalCtrl.dismiss({
            selected: true,
            membership: membership
        })
    }

    getClubImage(club: ClubInfo) {
        if (!club) return 'assets/image/default_club.png';
        let _club = JSON.parse(JSON.stringify(club));
        JsonService.deriveFullUrl(_club, "clubImage");
        JsonService.deriveFullUrl(_club, "clubLogo");
        JsonService.deriveFullUrl(_club, "clubThumbnail");
        if (_club && _club.clubLogo) return _club.clubLogo;
        else if (_club && _club.clubThumbnail) return _club.clubThumbnail;
        else if (_club && _club.clubImage) return _club.clubImage;
        else return 'assets/image/default_club.png'
    }
}
